"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/Accordion";
import { config } from "@/lib/config";
import React from "react";

interface Faq {
  question: string;
  answer: string;
  className?: string;
}

interface CommonFaqProps {
  faqs: Faq[];
  isDarkBackground?: boolean;
  className?: string;
}

const CommonFaqAccordion: React.FC<CommonFaqProps> = ({
  faqs,
  className,
  isDarkBackground = false,
}) => {
  return (
    <Accordion type="single" collapsible className={`${className} Faq-text `}>
      {faqs?.map((faq: any, index: number) => {
        const baseUrl = config.apiBase;

        const processHtml = (html: string) => {
          return html.replace(/src="\/(.*?)"/g, `src="${baseUrl}/$1"`);
        };
        return (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className={`${
              isDarkBackground ? "gradient-faq" : "banner-greadient"
            } px-[47px] py-[23px] rounded-[20px] mb-[25px] mobileMax:px-[20px] mobileMax:py-[15px] mobileMax:mb-5`}
          >
            <AccordionTrigger
              plusArrow
              noArrow
              className={`${
                isDarkBackground ? "text-[#003350]" : "text-[#fff]"
              } text-[21px] !py-0 font-semibold font-poppins leading-normal hover:no-underline text-left mobileMax:text-xsmall`}
              bgColor={isDarkBackground ? "bg-[#fff]" : "bg-[#003350]"}
            >
              {faq?.question}
            </AccordionTrigger>
            <AccordionContent>
              <p
                dangerouslySetInnerHTML={{
                  __html: processHtml(faq?.answer),
                }}
                className={`${
                  isDarkBackground ? "text-[#003350]" : "text-[#fff]"
                } font-poppins leading-normal pt-3 text-left mobileMax:text-xsmall`}
              />
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default CommonFaqAccordion;
